import { createBrowserRouter, RouteObject } from "react-router-dom";
import publicRoutes from "./publicRoutes";
import defaultRoutes from "./defaultRoutes";
import croatianOlympicCommitteeRoutes from "./croatianOlympicCommitteeRoutes";
import invoiceRoutes from "./invoiceRoutes";
import dmsRoutes from "./dmsRoutes";
import publicAdministrationRoutes from "./publicAdministrationRoutes";
import { isFeatureEnabled } from "@/state/store";
import { FeatureFlags } from "@/state/featureFlags";
import fallbackRoutes from "./fallbackRoutes";
import "dayjs/locale/hr";
import "dayjs/locale/en";
import epkRoutes from "./epkRoutes";
import eDeliveryRoutes from "./eDeliveryRoutes";
import reportsRoutes from "./reportsRoutes";
import KpiConfigurationRoutes from "./KpiConfigurationRoutes";

const buildRouter = () => {
	const protectedRoutes: RouteObject[] = [];

	protectedRoutes.push(...defaultRoutes);

	if (isFeatureEnabled(FeatureFlags.CroatianOlympicCommittee)) {
		protectedRoutes.push(...croatianOlympicCommitteeRoutes);
	}

	if (isFeatureEnabled(FeatureFlags.InvoicesModuleEnabled)) {
		protectedRoutes.push(...invoiceRoutes);
	}

	if (isFeatureEnabled(FeatureFlags.DmsModuleEnabled)) {
		protectedRoutes.push(...dmsRoutes);
	}

	if (isFeatureEnabled(FeatureFlags.PublicAdministrationModuleEnabled)) {
		protectedRoutes.push(...publicAdministrationRoutes);
	}

	if (isFeatureEnabled(FeatureFlags.EDeliveryModuleEnabled)) {
		protectedRoutes.push(...eDeliveryRoutes);
	}

	if (isFeatureEnabled(FeatureFlags.EpkModuleEnabled)) {
		protectedRoutes.push(...epkRoutes);
	}

	if (isFeatureEnabled(FeatureFlags.ReportsModuleEnabled)) {
		protectedRoutes.push(...reportsRoutes);
	}

	if (isFeatureEnabled(FeatureFlags.ReportsModuleEnabled)) {
		protectedRoutes.push(...KpiConfigurationRoutes);
	}

	const allRoutes = [
		...publicRoutes,
		{
			path: "/",
			lazy: () => import("@/layouts/BasicLayout"),
			children: [...protectedRoutes, ...fallbackRoutes]
		}
	];

	const router = createBrowserRouter(allRoutes, { basename: import.meta.env.VITE_PUBLIC_URL });

	return router;
};

export default buildRouter;
